 <template>
  <div>
    <div class="columns is-vcentered">
      <div class="column">
        <h1 class="is-size-6">Attachments</h1>
      </div>
      <div class="column has-text-right" v-if="!storageAvailable">
        <p class="has-text-danger is-size-6">Out of Storage</p>
      </div>
      <div class="column is-2 has-text-right" v-if="storageAvailable">
        <span v-if="uploading">Uploading ({{ progress }}%)</span>
        <div class="file" v-if="!uploading">
          <label class="file-label">
            <input
              class="file-input"
              type="file"
              accept="image/png, image/jpeg, image/jpg"
              @change="onAddClicked"
            />
            <span class="file-cta">
              <span class="file-label">Add</span>
            </span>
          </label>
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-vcentered" style="margin-top: 1rem;">
      <div class="column is-4" v-for="attachment in service.attachments" :key="attachment">
        <div class="preview">
          <img :src="attachment" />
          <a class="has-text-danger" @click="onRemoveClicked(attachment)">Remove</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "../../../../../http";
export default {
  props: {
    service: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      attachments: [],
      progress: 0,
      uploading: false,
      storageAvailable: true
    };
  },
  computed: {
    attachmentBaseUrl() {
      return `${process.env.VUE_APP_SERVICE_BASEURL ||
        "http://localhost:3000"}/storage`;
    },
    isActive() {
      return this.attachments.length < this.index;
    }
  },
  methods: {
    onAddClicked($event) {
      let component = this;
      let fileReader = new FileReader();
      fileReader.onload = function() {
        let image = new Image();
        image.onload = function() {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          let aspect = image.width / image.height;
          const size = 960;
          if (aspect > 1) {
            canvas.width = size;
            canvas.height = size / aspect;
          } else {
            canvas.height = size;
            canvas.width = size * aspect;
          }
          console.log(aspect, canvas.width, canvas.height);
          context.drawImage(
            image,
            0,
            0,
            image.width,
            image.height,
            0,
            0,
            canvas.width,
            canvas.height
          );
          component.$emit("add", canvas.toDataURL("image/jpeg"));
        };
        image.src = fileReader.result;
      };
      fileReader.readAsDataURL($event.target.files[0]);
    },
    onRemoveClicked(attachment) {
      this.$emit("remove", attachment);
    },
    fetchStorage() {
      let component = this;
      http.get("/stats/storage").then(response => {
        console.log(response.data.total);
        component.storageAvailable = response.data.total > response.data.used;
      });
    }
  },
  mounted() {
    this.fetchStorage();
  }
};
</script>
<style lang="scss" scoped>
#attachment-canvas {
  display: none;
}
.preview {
  display: flex;
  flex-direction: column;
  text-align: center;
  border: 1px solid hsl(0, 0%, 86%);
  a {
    padding: 0.5rem;
  }
}
.file {
  justify-content: end;
}
</style>